import { render, staticRenderFns } from "./DockingMasterDataJob.vue?vue&type=template&id=2138a6a0&scoped=true"
import script from "./DockingMasterDataJob.vue?vue&type=script&lang=js"
export * from "./DockingMasterDataJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2138a6a0",
  null
  
)

export default component.exports